import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'react-oidc-context';
import { loadGateStatus, type LoadInProgress } from './api';

const LOADING_POLL_MS = 2_500;
const IDLE_POLL_MS = 15_000;

/** Poll the load gate: is an import running (anyone's), and what. While it is,
 *  upload surfaces show the ban and disable their controls — one load at a
 *  time, so a concurrent upload can't race it at the store (the VDB-collision
 *  ban, user requirement 2026-09-02). Returns null when nothing is loading. */
export function useLoadGate(): LoadInProgress | null {
  const auth = useAuth();
  const token = auth.user?.id_token;
  const q = useQuery<LoadInProgress | null>({
    queryKey: ['load-gate'],
    enabled: !!token,
    // While a load or clear runs, a quick heartbeat so the ban clears promptly
    // on every open upload surface; while nothing runs, a slow one, which a
    // load started from this tab cuts short (LoadJobsProvider asks again at
    // once) and a return to the tab refreshes.
    refetchInterval: (query) => (query.state.data ? LOADING_POLL_MS : IDLE_POLL_MS),
    queryFn: async () => {
      const r = await loadGateStatus(token!);
      if (!r.ok) return null;
      return r.data.in_progress;
    },
  });
  return q.data ?? null;
}
